// import React from 'react'
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Navigations = ({ direction }: { direction?: string }) => {
  return (
    <div className="flex items-center gap-8">
      <motion.ul
        initial={{ opacity: 0, x: 200 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 200 }}
        className={`flex items-center gap-8 ${direction && direction}`}
      >
        <motion.li
          whileHover={{ scale: 1.1 }}
          className="text-base transition-all duration-100 ease-in-out cursor-pointer md:text-sm lg:text-md text-textColor hover:text-headingColor"
        >
          <Link to={"/"}>Trang chủ</Link>
        </motion.li>
      </motion.ul>
    </div>
  );
};

export default Navigations;
